import React from 'react';
import styled from 'styled-components/macro';
import NavElement from './NavElement';
import { Pages } from '../../../App';

interface Props {
	currentPage: number;
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
	isFairEnded: boolean;
}

var TOP_NAV_LINK = 'top-nav-link';

// Track New Purchase click
const trackNewPurchaseClick = () => {
	window._satellite.track(TOP_NAV_LINK, { pageName: 'New Purchase' });
};

// Track Process Refund click
const trackProcessRefundClick = () => {
	window._satellite.track(TOP_NAV_LINK, { pageName: 'Process Refund' });
};

// Track Sales Total click
const trackSalesTotalClick = () => {
	window._satellite.track(TOP_NAV_LINK, { pageName: 'Sales Total' });
};

const Navigation = ({ currentPage, setCurrentPage, isFairEnded }: Props) => {
	return (
		<Wrapper>
			{!isFairEnded && (
				<NavElement setCurrentPage={setCurrentPage} satelliteTracker={trackNewPurchaseClick} currentPage={currentPage} to={Pages.NewPurchase}>
					New Purchase
				</NavElement>
			)}
			{!isFairEnded && (
				<NavElement setCurrentPage={setCurrentPage} satelliteTracker={trackProcessRefundClick} currentPage={currentPage} to={Pages.ProcessRefund}>
					Process Refund
				</NavElement>
			)}
			<NavElement setCurrentPage={setCurrentPage} satelliteTracker={trackSalesTotalClick} currentPage={currentPage} to={Pages.SalesTotal}>
				Sales Total
			</NavElement>
		</Wrapper>
	);
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 16px 0 16px 0;
	gap 36px;
	@media (max-width: 380px) {
		gap: 16px;
	}
`;

export default Navigation;
